module.exports = __webpack_public_path__ + "img/f9443bc71cf898e17be27fc72616408b.984b9a3b.png";